"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionLevels = exports.AnswerTypes = exports.QuestionTypes = exports.InProgressTournamentStatus = exports.TournamentProgressStatus = exports.TournamentStatus = void 0;
var TournamentStatus;
(function (TournamentStatus) {
    TournamentStatus["PENDING"] = "pending";
    TournamentStatus["OPENED"] = "opened";
    TournamentStatus["IN_PROGRESS"] = "inProgress";
    TournamentStatus["FINISHED"] = "finished";
    TournamentStatus["PARTLY_FINISHED"] = "partlyFinished";
    TournamentStatus["DID_NOT_RUN"] = "didNotRun";
})(TournamentStatus = exports.TournamentStatus || (exports.TournamentStatus = {}));
var TournamentProgressStatus;
(function (TournamentProgressStatus) {
    TournamentProgressStatus["INVITED"] = "invited";
    TournamentProgressStatus["JOINED"] = "joined";
    TournamentProgressStatus["PARTICIPATED"] = "participated";
})(TournamentProgressStatus = exports.TournamentProgressStatus || (exports.TournamentProgressStatus = {}));
var InProgressTournamentStatus;
(function (InProgressTournamentStatus) {
    InProgressTournamentStatus["BETWEEN_ROUNDS"] = "betweenRounds";
    InProgressTournamentStatus["NEXT_ROUND_SCHEDULED"] = "nextRoundScheduled";
    InProgressTournamentStatus["QUESTION_IN_PROGRESS"] = "questionInProgress";
    InProgressTournamentStatus["ANSWER_REVEALED"] = "answerRevealed";
})(InProgressTournamentStatus = exports.InProgressTournamentStatus || (exports.InProgressTournamentStatus = {}));
var QuestionTypes;
(function (QuestionTypes) {
    QuestionTypes["MULTICHOICE"] = "multichoice";
    QuestionTypes["BINARY_CHOICE"] = "binary_choice";
    QuestionTypes["QUAD_CHOICE"] = "quad_choice";
    QuestionTypes["SNIPPET_BINARY_CHOICE"] = "snippet_binary_choice";
    QuestionTypes["SINGLE_SELECT_REMEDIATION"] = "single_select_remediation";
    QuestionTypes["CORRECT_CODE"] = "correctCode";
})(QuestionTypes = exports.QuestionTypes || (exports.QuestionTypes = {}));
var AnswerTypes;
(function (AnswerTypes) {
    AnswerTypes["SINGLE_ANSWER"] = "single";
    AnswerTypes["MULTIPLE_ANSWER"] = "multiple";
})(AnswerTypes = exports.AnswerTypes || (exports.AnswerTypes = {}));
var QuestionLevels;
(function (QuestionLevels) {
    QuestionLevels["BEGINNER"] = "Begginer";
    QuestionLevels["INTERMEDIATE"] = "Intermediate";
    QuestionLevels["EXPERT"] = "Expert";
})(QuestionLevels = exports.QuestionLevels || (exports.QuestionLevels = {}));
